/**
 * Finding #7 — generation-aware staleness check for a streamed `ImportAnalysis`
 * snapshot. Split out of `dataImportStore.actions.ts` purely to keep that file
 * under the 200-line cap (it was already at the cap before this fix).
 *
 * `revision` restarts at 0/1 on EVERY `analyzeImportFile` call — a fresh
 * re-analyze (rowFilter/parse-option change) on the same file gets its own
 * counter, so comparing revisions ACROSS two different calls is meaningless (a
 * slower OLDER call's later, higher-numbered partial can otherwise out-rank a
 * faster NEWER call's early, lower-numbered one and get stuck rejecting it).
 * `generation` orders calls by invocation order regardless of how many
 * revisions each accumulates; only fall back to `revision` when both snapshots
 * share a generation. Mirrors `electron/data-import/analysisRegistry.ts`'s own
 * `isStaleAnalysis` (kept as a separate small copy — main/renderer don't share
 * a module here).
 */
import type { ImportAnalysis } from '../../../../types/electron';

export function isStaleAnalysis(incoming: ImportAnalysis, existing: ImportAnalysis): boolean {
  const incomingGen = incoming.generation ?? 0;
  const existingGen = existing.generation ?? 0;
  if (incomingGen !== existingGen) return incomingGen < existingGen;
  return incoming.revision < existing.revision;
}
